import { notificationsAxiosConfig } from "../../../config/axios.config"

export async function configureNotifications({
	token,
	subscriberId,
	email,
}: {
	subscriberId: string
	email: string
	token: string
}) {
	const response = await notificationsAxiosConfig.post(
		"/subscriber",
		{
			email,
			subscriberId,
		},
		{
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		}
	)

	const { data } = response
	return data
}
